"use client";
import o, { useContext as le, useState as a, useEffect as f, useCallback as I, useMemo as M } from "react";
import F from "styled-components";
import "./index.es44.js";
import g from "./index.es45.js";
import "./index.es46.js";
import "./index.es47.js";
import "./index.es48.js";
import "./index.es49.js";
import "./index.es50.js";
import "./index.es51.js";
import ce from "./index.es52.js";
import me from "./index.es53.js";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import E from "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import { regionsFromParams as B, isRegionSelectionEqual as pe, isGeoType as ue } from "./index.es4.js";
import ge from "./index.es54.js";
import $ from "./index.es55.js";
import { RouterContext as de } from "./index.es5.js";
const ye = F.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`, he = F.div`
  background: #fff;
  .comparison-input-buttons {
    display: flex;
    & > * {
      margin-right: 0.5rem;
      margin-top: 1.75rem;
    }
  }
  fieldset {
    border: none;

    caption {
      display: inline-block;
    }
  }
`, tn = ({
  monitorType: d,
  regionsData: y,
  groupSlug: H,
  onChange: L
}) => {
  const { useRouter: U, useSearchParams: T, usePathname: q } = le(de), l = T(), z = U(), O = q(), P = (t) => {
    const n = t ? `?${t}` : "";
    z.push(`${O}${n}`);
  }, S = (t) => {
    const n = new URLSearchParams();
    for (const i in t) {
      const b = t[i];
      Array.isArray(b) ? b.forEach((se) => {
        n.append(i, se);
      }) : n.append(i, b);
    }
    return n;
  }, [e, c] = a(
    B(l, y)
  ), [m, p] = a(null), [r, k] = a(
    d === "ChildPoverty" ? ["barn", "prosent"] : ["andel"]
  ), [h, u] = a([]), [s, C] = a(!1), [G, w] = a(), [V, A] = a([]), [_, N] = a(!1);
  f(() => {
    if (e.primaryRegion) {
      const n = v(e.primaryRegion).map((i) => i.value);
      m ? n.includes(m) || p(n[n.length - 1]) : n.includes("County") ? p("County") : p(n[n.length - 1]);
    } else
      p(null);
  }, [e]), f(() => {
    L({
      regionSelection: e,
      compareScope: m || "Country",
      categories: r
    });
  }, [e, m, r]), f(() => {
    const t = B(l, y);
    pe(t, e) || (e.primaryRegion ? P(
      S({
        primary: e.primaryRegion.regionCode,
        regions: e.otherRegions.map((n) => n.regionCode)
      })
    ) : P(S({})));
  }, [e]), f(() => {
    if (!l) return;
    ((n) => {
      if (window !== void 0) {
        const i = new URL(
          `${window?.location?.origin}${window?.location?.pathname}?${n}${window?.location?.hash}`
        );
        history.pushState({}, "", i);
      }
    })(l);
  }, [l]);
  const j = (t, n) => {
    c({
      ...e,
      primaryRegion: t,
      otherRegions: n
    });
  }, K = () => {
    w(e.primaryRegion || void 0), N(!0), A([...e.otherRegions]), c({
      primaryRegion: null,
      otherRegions: []
    });
  }, W = () => {
    K();
  }, J = () => {
    w(e.primaryRegion || void 0), A(e.otherRegions || []), N(!1), c({ ...e, primaryRegion: null });
  }, Q = () => {
    u([...e.otherRegions]), C(!0);
  }, X = (t) => {
    const n = /* @__PURE__ */ new Set([...t]), i = Array.from(n);
    u(i);
  }, Y = () => {
    C(!1), c({
      ...e,
      otherRegions: [...h]
    }), u([]);
  }, Z = () => {
    C(!1);
  }, D = (t) => {
    c({ ...e, otherRegions: [...t] });
  }, ee = (t) => {
    u([...t]);
  }, ne = () => {
    u([...e.otherRegions]), C(!0);
  }, x = d === "ChildWelfare" ? ["County", "Municipality", "Cooperation", "CityPart", "Grouping"] : ["County", "Municipality", "CityPart", "CitySubPart"], te = (t) => {
    switch (t.type) {
      case "Country":
        return { value: "Country", display: "Norge" };
      case "Region":
        return { value: "Region", display: "Landsdel" };
      case "County":
        return { value: "County", display: "Fylke" };
      case "Municipality":
        return { value: "Municipality", display: "Kommune" };
      case "CityPart":
        return {
          value: "CityPart",
          display: "Bydel"
        };
    }
    return null;
  }, v = (t) => {
    if (!t.parent)
      return [];
    const n = te(t.parent);
    return n ? [...v(t.parent), n] : [];
  }, R = {
    name: "global-compare",
    value: m,
    choices: e.primaryRegion ? v(e.primaryRegion) : [],
    onChange: (t) => {
      ue(t) && p(t);
    }
  }, oe = I(
    (t) => {
      const n = [...r], i = n.length ? n.length - 1 : 0;
      n[i] = t, k(n);
    },
    [r]
  ), re = I(
    (t) => {
      const n = [...r];
      n.length > 1 && (n[0] = t, k(n));
    },
    [r]
  ), ie = M(
    () => ({
      name: "unitsCategoryInput",
      value: r.includes("andel") ? "andel" : r.includes("prosent") ? "prosent" : "antall",
      choices: [
        {
          value: d === "ChildPoverty" ? "prosent" : "andel",
          display: "Andel"
        },
        { value: "antall", display: "Antall" }
      ],
      onChange: oe
    }),
    [r, d]
  ), ae = M(
    () => ({
      name: "entityCategoryInput",
      value: r.includes("husholdning") ? "husholdning" : "barn",
      choices: [
        {
          value: "barn",
          display: "Barn"
        },
        { value: "husholdning", display: "Husholdning" }
      ],
      onChange: re
    }),
    [r]
  );
  return /* @__PURE__ */ o.createElement(he, { className: "bl-border--large bl-border--sand-3" }, /* @__PURE__ */ o.createElement("div", { className: "bl-p-a-4" }, !e.primaryRegion && /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement("h2", { className: "bl-size-3 bl-text-neutral-1 bl-m-b-3" }, "Velg sted"), /* @__PURE__ */ o.createElement(
    ce,
    {
      regionsData: y,
      onChange: j,
      includeTypes: x,
      previousRegion: G,
      previousComparisonRegions: V,
      clearComparisonRegions: _
    }
  )), e.primaryRegion && /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement("h2", { className: "bl-size-3 bl-text-neutral-1 bl-m-b-3" }, "Hvilke steder vil du sammenligne med?"), /* @__PURE__ */ o.createElement("fieldset", null, /* @__PURE__ */ o.createElement("legend", { className: "bl-p-b-2" }, "Ditt valgte utgangspunkt:"), /* @__PURE__ */ o.createElement(ge, null, /* @__PURE__ */ o.createElement(g, { isSmall: !0, onClick: W, iconName: "close" }, e.primaryRegion.name), e.otherRegions.length > 0 && !s && /* @__PURE__ */ o.createElement(
    g,
    {
      isSmall: !0,
      onClick: J,
      styleType: "secondary",
      iconName: "pencil"
    },
    "Endre utgangspunkt"
  ), e.otherRegions.length === 0 && !s && /* @__PURE__ */ o.createElement(
    g,
    {
      isSmall: !0,
      onClick: Q,
      styleType: "secondary",
      iconName: "plus-circle"
    },
    "Legg til sted"
  )))), e.primaryRegion && (e.otherRegions.length > 0 || h.length > 0) && /* @__PURE__ */ o.createElement("fieldset", null, /* @__PURE__ */ o.createElement("legend", { className: "bl-p-y-2" }, "Valgte steder for sammenligning:"), !s && /* @__PURE__ */ o.createElement(
    $,
    {
      key: "other-regions-display-mode",
      regions: e.otherRegions,
      includeAddButton: !0,
      onChange: D,
      onAddClick: ne
    }
  ), s && /* @__PURE__ */ o.createElement(
    $,
    {
      key: "other-regions-input-mode",
      regions: h,
      includeAddButton: !1,
      onChange: ee
    }
  )), e.primaryRegion && s && /* @__PURE__ */ o.createElement("div", null, /* @__PURE__ */ o.createElement(
    me,
    {
      regionsData: y,
      comparisonRegions: h,
      primaryRegion: e.primaryRegion,
      geoTypes: x,
      onSelect: X
    }
  ), /* @__PURE__ */ o.createElement("div", { className: "comparison-input-buttons" }, /* @__PURE__ */ o.createElement(g, { onClick: Z, styleType: "secondary" }, "Avbryt"), /* @__PURE__ */ o.createElement(g, { onClick: Y }, "Oppdater resultat"))), !!e.primaryRegion && !s && !H && /* @__PURE__ */ o.createElement("div", null, /* @__PURE__ */ o.createElement("h2", { className: "bl-size-3 bl-text-neutral-1 bl-m-y-3" }, "Hvordan vil du se dataene?"), /* @__PURE__ */ o.createElement(ye, null, R.choices.length > 1 && R.value !== null && /* @__PURE__ */ o.createElement(
    E,
    {
      label: "Hva vil du sammenligne med?",
      ...R,
      value: R.value || ""
    }
  ), /* @__PURE__ */ o.createElement(
    E,
    {
      label: "Hvordan vi du se det?",
      ...ie
    }
  ), r.length > 1 && /* @__PURE__ */ o.createElement(E, { label: "Hva vi du se?", ...ae })))));
};
export {
  tn as default
};
//# sourceMappingURL=index.es35.js.map
